<template>
  <div class="card-columns" id="equipments-assigned">
    <div
      v-for="(equipmentList, groupName) in equipments"
      v-show="equipmentList.length !== 0"
      :key="groupName"
      class="card"
    >
      <div class="card-header bg-primary text-light">{{ groupName }}</div>
      <ul class="equipment-list list-group list-group-flush">
        <li
          v-for="equipment in equipmentList"
          class="list-group-item d-flex justify-content-between"
          :key="`li-${equipment.id}`"
        >
          <Component
            :is="useTrimEquipmentItems ? 'TrimEquipmentItem' : 'EquipmentItem'"
            :key="equipment.id"
            :value="equipment"
            :group="groupName"
            :trim-equipment-route="trimEquipmentRoute"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import EquipmentItem from '@components/equipment/EquipmentItem.vue'
import GroupHeader from '@components/equipment/GroupHeader.vue'
import TrimEquipmentItem from '@components/equipment/TrimEquipmentItem.vue'

export default {
  name: 'EquipmentList',
  components: {
    GroupHeader,
    EquipmentItem,
    TrimEquipmentItem
  },
  props: {
    equipments: {
      type: Object,
      default() {
        return {}
      }
    },
    useTrimEquipmentItems: {
      type: Boolean,
      default: false
    },
    trimEquipmentRoute: {
      type: String,
      default: '#'
    }
  }
}
</script>

<style scoped>
.list-group-item {
  position: unset;
}
.card-header {
  border-bottom: none;
}

label {
  all: unset;
}

.card-body {
  padding-top: 0;
}

.form-inline {
  flex-direction: row-reverse;
}

.btn-sm {
  margin-left: 5px;
}
</style>
